import { render } from "./delivery-performance-summary-card.vue?vue&type=template&id=533bc338&scoped=true&ts=true"
import script from "./delivery-performance-summary-card.vue?vue&type=script&lang=ts"
export * from "./delivery-performance-summary-card.vue?vue&type=script&lang=ts"

import "./delivery-performance-summary-card.vue?vue&type=style&index=0&id=533bc338&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533bc338"]])

export default __exports__